/* eslint-disable import/no-cycle */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleNotch, faPause, faStop, faCheck, faTimesCircle, faLock} from '@fortawesome/free-solid-svg-icons';

import i18n from '../../i18n/i18n';
import WidgetSettingFormField from '../shared/widgets/WidgetSettingFormField';

const iconElements = {
  planned: faStop,
  paused: faPause,
  active: faCircleNotch,
  finished: faCheck,
  aborted: faTimesCircle,
  disabled: faLock,
};

export const iconNames = Object.keys(iconElements);

/**
 * context translations:
 * t('orderWidget.settings.icon.planned')
 * t('orderWidget.settings.icon.paused')
 * t('orderWidget.settings.icon.active')
 * t('orderWidget.settings.icon.finished')
 * t('orderWidget.settings.icon.aborted')
 * t('orderWidget.settings.icon.disabled')
 */
export const getIcon = (name, withLabel = true) => (
  <>
    <FontAwesomeIcon icon={iconElements[name]}/>
    {withLabel && ` - ${i18n.t(`orderWidget.settings.icon.${name}`)}`}
  </>
);

const iconSelectOptions = iconNames.map((value) => ({
  value,
  label: getIcon(value),
}));

/**
 * context translations:
 * t('orderWidget.settings.icon.select.label.planned')
 * t('orderWidget.settings.icon.select.label.active')
 * t('orderWidget.settings.icon.select.label.paused')
 * t('orderWidget.settings.icon.select.label.paused')
 * t('orderWidget.settings.icon.select.label.finished')
 * t('orderWidget.settings.icon.select.label.aborted')
 * t('orderWidget.settings.icon.select.label.disabled')
 */
export const iconSelects = iconNames.map((name, defaultValue) => ({
  id: `icon.${name}`,
  label: i18n.t(`orderWidget.settings.icon.select.label.${name}`),
  type: WidgetSettingFormField.fieldTypes.Select,
  defaultValue: iconNames[defaultValue],
  options: iconSelectOptions,
}));
